import { Component, inject } from '@angular/core';
import { CommonModule, AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { ThemeToggleService } from '../../partials/theme-toggle/theme-toggle.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterLink, AsyncPipe],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  host: { 'class': 'block min-h-screen w-full' }
})
export class HomeComponent {
  authService = inject(AuthService);
  themeService = inject(ThemeToggleService);

  onThemeToggle(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input) {
      this.themeService.setThemeMode(input.checked ? 'dark' : 'light');
    }
  }

  logout() {
    this.authService.logout();
  }
}
